<ng-template #pageTitle>
  <h5 class="text-neutral-900 font-semibold text-2xl">
    {{ 'user_management_variables_screen_title' | transloco }}
  </h5>
</ng-template>

<div
  class="flex flex-col h-full"
  [class]="floatingPageClasses()"
  [class.gap-2xl]="!floating()"
  [class.gap-lg]="floating() && !systemTabs()">
  <!-- System_Tabs on the floating page: title and segmented tabs on the grey, content in the card -->
  @if (!(floating() && systemTabs())) {
    <ng-container [ngTemplateOutlet]="pageTitle" />
  }

  <lib-tabs
    [class]="floating() && !systemTabs() ? 'block floating-card p-2xl' : ''"
    [tabSegmented]="systemTabs()"
    [tabsStartRef]="floating() && systemTabs() ? pageTitle : null"
    [tabsContentClass]="floating() && systemTabs() ? 'floating-card p-2xl' : ''"
    [tabsBorder]="!systemTabs()"
    [tabsClass]="'border-neutral-300'">
    <lib-tab
      [tabTitle]="
        'user_management_variables_single_variables_tab_title' | transloco
      "
      #singleVariablesTab>
      @if (singleVariablesTab.active()) {
        <lib-single-variable-list
          [variableModule]="'user_management'"
          [variableType]="'single'"></lib-single-variable-list>
      }
    </lib-tab>
  </lib-tabs>
</div>
